export const platformVersion = '^21.1.1';
